// extracted by mini-css-extract-plugin
export default {"cls1":"nskunHY_ReBNwTkzMykX","cls2":"DzWU4RwFFCmBOYxXB77E nskunHY_ReBNwTkzMykX"};